import { object, number, array, mixed, boolean } from 'yup';

import { YUP_ERRORS_MESSAGES } from '@shared/constants';
import { getRewardValueValidationSchema } from '@shared/utils';

import { UserRewardType } from 'v2/constants';

export const referralValidationSchema = object().shape({
  requiredTasksForValidate: number()
    .min(0, 'Value must be a non-negative integer')
    .max(5, 'Value must be less than or equal to 5')
    .required(YUP_ERRORS_MESSAGES.REQUIRED),
  inviterRewards: array().of(
    object().shape({
      type: mixed().oneOf(Object.values(UserRewardType)).required(YUP_ERRORS_MESSAGES.REQUIRED),
      value: getRewardValueValidationSchema(),
    })
  ),
  referralRewards: array().of(
    object().shape({
      type: mixed().oneOf(Object.values(UserRewardType)).required(YUP_ERRORS_MESSAGES.REQUIRED),
      value: getRewardValueValidationSchema(),
    })
  ),
  isActive: boolean().required(YUP_ERRORS_MESSAGES.REQUIRED),
});
